<template>
    <!-- List agents component -->
    <div class="card" style="min-height: 450px;">
        <h6 class="card-header" style="color:#348cd4;" > List of Agents</h6>

        <div class="row card-body">
            <div class="col-md-8 m-auto">

                <div class="form-group row justify-content-start ml-1">
                    <label class="col-md-2 pl-0">State</label>
                    <div class="col-md-6 pl-0">
                        <select class="form-control form-control-sm" v-model="lstate">
                        <option value="">-select a state - </option>
                        <option v-for="(state, index) in everyStates" :value="state.stateName" :key="index">{{ state.stateName }}</option>
                        </select>
                    </div>
                </div>

                <div class="form-group row mb-4 justify-content-start ml-1">
                    <label class="col-md-2 pl-0">Account status</label>
                    <div class="col-md-6 pl-0">
                        <select class="form-control form-control-sm" v-model="accStatus">
                        <option value="">-select status - </option>
                        <option value="1">Active </option>
                        <option value="0">Suspended </option>
                        </select>
                    </div>
                </div>

                <div class="form-group row ml-1 mr-2" >
                    <label class="col-md-2 pl-0"></label>
                    <button class="btn btn-primary btn-sm col-md-6" @click="getAgentList()">Fetch Data</button>
                </div>

            </div>
            <!-- end col-8 -->
        </div>

        <vue-bootstrap4-table
            v-if="agentFetched"
            :rows="rows"
            :columns="columns"
            :config="config"
            :actions="actions"
            @on-select-row="editSelected"
            @on-all-select-rows="editSelected"
            @on-unselect-row="editSelected"
            @oon-all-unselect-rows="editSelected"
            @on-suspend="suspendAgents">
            <template slot="empty-results">
                No Agent found
            </template>
            <template slot="id" slot-scope="props">
                <span>
                    {{props.row.vbt_id}}
                </span>
            </template>
            <template slot="accountStatus" slot-scope="props">
                <span>
                    {{(props.cell_value == 1)? 'Active' : 'Suspended'}}
                </span>
            </template>
            <template slot="action" slot-scope="props">
                <span>
                    <a @click="$emit('show-details', props.cell_value)"  class="btn btn-primary btn-xs" style="font-size:10px; color:#fff;"><v-icon name="eye" style="width:14px"></v-icon></a>
                </span>
            </template>
            <template slot="sort-asc-icon">
                <i class="fas fa-sort-up"></i>
            </template>
            <template slot="sort-desc-icon">
                <i class="fas fa-sort-down"></i>
            </template>
            <template slot="no-sort-icon">
                <i class="fas fa-sort"></i>
            </template>
        </vue-bootstrap4-table>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapState, mapGetters, mapActions } from 'vuex';
import VueBootstrap4Table from 'vue-bootstrap4-table'

export default {
    name: 'ListAgents',
    components:{
        VueBootstrap4Table,
    },

    data() {
        return{
            agentFetched: false,
            fetchedAgents: [],
            lstate: null,
            accStatus: null,
            selectedRows: [],
            rows: [],
            columns: [
                {
                    label: "S/N",
                    name: "id",
                    slot_name: "id"
                },
                {
                    label: "Agent ID",
                    name: "agentId",
                    sort: true,
                },
                {
                    label: "Email",
                    name: "email",
                    sort: true,
                },
                {
                    label: "Phone",
                    name: "phone",
                    sort: true,
                },
                {
                    label: "Company Name",
                    name: "companyName",
                    sort: true,
                },
                {
                    label: "Tax ID",
                    name: "taxId",
                    sort: true,
                },
                {
                    label: "Account Status",
                    name: "accountStatus",
                    slot_name: "accountStatus",
                    sort: true,
                },
                {
                    label: "Action",
                    name: "id",
                    slot_name: "action",
                },
            ],
            actions: [
                {
                    btn_text: "Suspend",
                    event_name: "on-suspend",
                    class: "btn btn-secondary btn-sm",
                    event_payload: this.selectedRows
                }
            ],
            config: {
                card_mode: false,
                show_refresh_button: false,
                show_reset_button: false,
                checkbox_rows: true,
                rows_selectable: true,
                selected_rows_info: true,
                global_search: {
                    placeholder: "Search Uploads",
                    visibility: false,
                    case_sensitive: false,
                },
            }
        }
    },

    computed:{
        ...mapState(['token', 'refreshAgentsList']),
        ...mapGetters(['everyStates']),
    },

    watch:{
        refreshAgentsList(val, oldVal){
            if (val == true) {
                console.log("hello refresh")
                this.fetchedAgents = []
                this.getAgentList()

                this.update_refreshAgentsList(false)
            }
        }
    },

    methods:{
        ...mapActions(['update_refreshAgentsList']),

        editSelected(selectedItems){
            this.selectedDeleteRows = selectedItems.selected_items
            // console.log("selectedItems-------",this.selectedDeleteRows)
        },

        getAgentList(){
            this.$toastr.removeByType("error"); // remove all error type message

            if(!this.fetchedAgents.length){
                const baseU = `${this.$urlAuth}/agents`;

                this.$http.get(baseU,{
                    headers:{
                        "x-access-token":this.token
                    }
                })
                .then(response => {
                    console.log(response.data.data.code);
                    if(response.data.data.code =='S200'){
                        this.agentFetched = true

                        if (response.data.data.agents.length) {
                            this.fetchedAgents = response.data.data.agents

                            if (this.lstate && this.accStatus) {
                                this.rows = this.fetchedAgents.filter(agent => agent.stateAddress == this.lstate && agent.accountStatus == this.accStatus)
                                return
                            }else if (this.lstate) {
                                this.rows = this.fetchedAgents.filter(agent => agent.stateAddress == this.lstate)
                                return
                            }else if (this.accStatus) {
                                this.rows = this.fetchedAgents.filter(agent => agent.accountStatus == this.accStatus)
                                return
                            }else{
                                this.rows = this.fetchedAgents
                            }
                        }else if (response.data.data.message){
                            this.$toastr.e(response.data.data.message);
                            this.rows = [];
                        }

                    }else{
                        this.$toastr.e(response.data.data.message);
                        this.rows = [];
                    }
                })
                .catch(err => {
                    // console.log(err)
                    this.$toastr.e('Network error, unable to connect')
                })
            }else if (this.lstate && this.accStatus) {
                this.rows = this.fetchedAgents.filter(agent => agent.stateAddress == this.lstate && agent.accountStatus == this.accStatus)
                return
            }else if (this.lstate) {
                this.rows = this.fetchedAgents.filter(agent => agent.stateAddress == this.lstate)
                return
            }else if (this.accStatus) {
                this.rows = this.fetchedAgents.filter(agent => agent.accountStatus == this.accStatus)
                return
            }else{
                this.rows = this.fetchedAgents
            }
        },

        suspendAgents({selectedItems}){
            const suspendAgentsCount = prompt('Are you sure you want to suspend these agents? \nInput the total number of agents to suspend')
            if (suspendAgentsCount != selectedItems.length) {
                return
            }
            const baseU = `${this.$urlAuth}/agent/suspend`

            const agentIds = selectedItems.map(agent => agent.agentId)

            // console.log(agentIds)

            this.$http.post(baseU,{agentId: agentIds},{
                headers:{
                    "x-access-token":this.token
                }
            })
            .then(response => {
                if(response.data.data.code == 'S200'){
                    this.$toastr.s(response.data.data.message);

                    // refresh agents list
                    this.fetchedAgents = []
                    this.getAgentList()
                    
                }else{
                    this.$toastr.e(response.data.data.message);
                }
            })
            .catch(e => {
               this.$toastr.e('Network error, unable to connect deleted'); 
            })
        }
    }
}
</script>